import type { ImgHTMLAttributes } from "react";
import { cn } from "@base/ui";
import logoCreativeOs from "../../id/CreativeOS.png";

type PropsDaLogo = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  "src" | "alt" | "children"
>;

/**
 * Marca do produto: wordmark Creative OS.
 *
 * O PNG é preto. A classe `marca-escura` deixa branco no tema escuro (padrão),
 * por CSS próprio — não depende do variant `dark:` do Tailwind.
 */
export function LogoRenkeRefs({ className, ...resto }: PropsDaLogo) {
  return (
    <img
      {...resto}
      src={logoCreativeOs}
      alt="Creative OS"
      className={cn(
        "logo-renke-refs marca-escura block h-5 w-auto max-w-full select-none object-contain object-left",
        className,
      )}
    />
  );
}
